const e = (t) => ({
  wrapper: {
    backgroundColor: t.palette.common.blue20
  },
  row: {
    alignItems: "center"
  },
  content: {
    "@media(max-width: 600px)": {
      textAlign: "center"
    }
  },
  title: {
    color: t.palette.common.blue400,
    "@media(max-width: 600px)": {
      fontSize: t.typography.fontSize22
    }
  },
  description: {
    fontSize: t.typography.fontSize18,
    "@media(max-width: 600px)": {
      fontSize: t.typography.fontSize14
    }
  },
  quoteBtn: {
    maxWidth: 260,
    textTransform: "capitalize",
    "@media(max-width: 600px)": {
      maxWidth: "100%"
    }
  },
  imgWrapper: {
    backgroundColor: t.palette.common.white,
    textAlign: "center",
    borderRadius: 8,
    minHeight: 260,
    "& > img": {
      width: "100%",
      borderRadius: 8
    }
  }
}), o = e;
export {
  o as default
};
